var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 214,
    viewBox: "0 0 201 214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 107A100 100 0 00102 7M107 13l-5-6 5-6"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 106.5a100 100 0 0098 100M94 200.5l5 6-5 6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65 45)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#e7eef1",
    opacity: 0.7,
    width: 70,
    height: 124,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 110.5h20",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotationIcon);
export default __webpack_public_path__ + "static/media/rotation-icon.0053c44b6657767e3ba63511654ac949.svg";
export { ForwardRef as ReactComponent };